import { createSlice } from '@reduxjs/toolkit';
import { getFromStorage } from '@forvalter/utils/storage';
import type {
    FilterStateKey,
    filterStateKeys,
} from '@klp/design/PersistentFilter/config';
import { filterTableConfig } from '@klp/design/PersistentFilter/config';
import { capitalize } from '@forvalter/utils/TypeScriptUtils';
import type { PayloadAction } from '@reduxjs/toolkit';

export type IUxState = {
    [K in (typeof filterStateKeys)[number]]?: Array<Array<string>>;
};

export type IUxStore = {
    ux: IUxState;
};

const filterInitialState = Object.fromEntries(
    Object.values(filterTableConfig).map(({ stateKey, storageKey }) => [
        stateKey,
        getFromStorage(storageKey) as Array<Array<string>> | undefined,
    ]),
) as Pick<IUxState, FilterStateKey>;

export const initialState: IUxState = {
    ...filterInitialState,
};

export const uxSlice = createSlice({
    name: 'ux',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        for (const [
            _key,
            { stateKey, storageKey: _storageKey, actionPrefix },
        ] of Object.entries(filterTableConfig)) {
            const saveType = `${actionPrefix}/save${capitalize(stateKey)}/fulfilled`;
            const clearType = `${actionPrefix}/clear${capitalize(stateKey)}/fulfilled`;

            builder.addCase<string, PayloadAction<Array<Array<string>>>>(
                saveType,
                (state, action) => {
                    state[stateKey] = action.payload;
                },
            );

            builder.addCase<string, PayloadAction<void>>(clearType, (state) => {
                state[stateKey] = undefined;
            });
        }
    },
});

export const uxSelectors = ({ ux }: IUxStore): IUxState => ux;

export const uxReducer = uxSlice.reducer;
